import React from 'react';
export var InfoStatusIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16", width: "16", height: "16" },
    React.createElement("circle", { fill: "#4997c7", cx: "8", cy: "8", r: "7" }),
    React.createElement("path", { fill: "#fff", d: "M8.04,3a1,1,0,1,0,1,1A1,1,0,0,0,8.04,3Z" }),
    React.createElement("rect", { fill: "#fff", x: "7.25", y: "6", width: "1.5", height: "7" }))); };
//# sourceMappingURL=InfoStatusIcon.js.map